import { render, staticRenderFns } from "./MemberProfiles.vue?vue&type=template&id=87920b32"
import script from "./MemberProfiles.vue?vue&type=script&lang=js"
export * from "./MemberProfiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports